import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { SVGFC } from '@repo/toolkit/types'

const QuestionMark2Icon: SVGFC = ({ color = tailwindColors.secondary.DEFAULT, ...props }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_22638_75033)">
        <path
          d="M12.2105 11.866L14.7852 9.84914L15.1871 6.33788L12.2105 4.69922L11.0022 6.35982C11.6275 6.6738 12.0716 7.3006 12.125 8.03188C12.192 8.95172 11.6343 9.80812 10.7681 10.1141C9.61722 10.5214 8.84375 11.6201 8.84375 12.8483V13.3759C8.84375 14.0632 9.40091 14.6204 10.0879 14.6204H11.9078L12.2105 11.866Z"
          fill={color}
        />
        <path
          d="M8.62077 9.43177H6.80096C6.11374 9.43177 5.55664 8.87467 5.55664 8.18745C5.55664 7.97679 5.57134 7.7647 5.6003 7.55707C5.92632 5.22058 8.03047 3.51108 10.3906 3.66599H12.2107L10.9159 4.97342"
          fill={color}
        />
        <path
          d="M11.9084 15.8262H10.0886C9.40134 15.8262 8.84424 16.3833 8.84424 17.0705V17.0808C8.84424 17.768 9.40134 18.3251 10.0886 18.3251H11.6871"
          fill={color}
        />
        <path
          d="M11.9092 14.6184C11.222 14.6184 10.6649 14.0612 10.6649 13.374V12.8462C10.6649 11.618 11.4383 10.5194 12.5895 10.1124C13.4554 9.80622 14.0133 8.94991 13.9463 8.03004C13.8728 7.02277 13.0573 6.21341 12.0493 6.14741C10.9831 6.07697 10.0331 6.84699 9.88633 7.89904C9.87321 7.99309 9.86657 8.08948 9.86657 8.18553C9.86657 8.87274 9.30946 9.42985 8.62225 9.42985C7.93503 9.42985 7.37793 8.87274 7.37793 8.18553C7.37793 7.97487 7.39263 7.76277 7.42159 7.55515C7.7476 5.21862 9.85173 3.50912 12.2119 3.66404C14.4524 3.81077 16.2652 5.60995 16.4284 7.84908C16.5767 9.8842 15.3393 11.7797 13.4191 12.4587C13.2603 12.5148 13.1536 12.6706 13.1536 12.8462V13.374C13.1536 14.0612 12.5965 14.6184 11.9092 14.6184Z"
          fill={color}
        />
        <path
          d="M11.9094 18.3232C11.2221 18.3232 10.665 17.7661 10.665 17.0788V17.0685C10.665 16.3813 11.2221 15.8242 11.9094 15.8242C12.5966 15.8242 13.1537 16.3813 13.1537 17.0685V17.0788C13.1537 17.7661 12.5966 18.3232 11.9094 18.3232Z"
          fill={color}
        />
        <path
          d="M8.52156 7.55539C8.49234 7.76299 8.47804 7.97491 8.47804 8.18563C8.47804 8.67539 8.76084 9.09926 9.17228 9.3019C9.00633 9.38394 8.81988 9.42995 8.62222 9.42995C7.93544 9.42995 7.37793 8.87307 7.37793 8.18566C7.37793 7.97497 7.39285 7.76302 7.42204 7.55542C7.74775 5.21846 9.85224 3.50925 12.2122 3.66403C12.2967 3.66961 12.3806 3.67769 12.4639 3.68826C10.4657 3.93439 8.80807 5.50312 8.52156 7.55539Z"
          fill={color}
        />
        <path
          d="M13.6894 10.1137C12.5383 10.5208 11.7645 11.6197 11.7645 12.8478V13.3755C11.7645 13.8653 12.0479 14.2892 12.4594 14.4918C12.2934 14.5738 12.107 14.6198 11.9093 14.6198C11.2219 14.6198 10.665 14.0629 10.665 13.3755V12.8478C10.665 11.6197 11.4382 10.5208 12.5899 10.1137C13.4557 9.80729 14.0132 8.95147 13.9461 8.03159C13.8833 7.16643 13.273 6.4473 12.4631 6.22046C12.6813 6.15893 12.9125 6.13343 13.1493 6.14899C14.1574 6.21487 14.9728 7.02409 15.0462 8.03159C15.1133 8.95147 14.5551 9.80732 13.6894 10.1137Z"
          fill={color}
        />
        <path
          d="M12.4594 18.1953C12.2934 18.2774 12.107 18.3234 11.9093 18.3234C11.2219 18.3234 10.665 17.7665 10.665 17.0791V17.0685C10.665 16.3817 11.2219 15.8242 11.9093 15.8242C12.107 15.8242 12.2934 15.8702 12.4594 15.9523C12.0479 16.1555 11.7645 16.5794 11.7645 17.0685V17.0791C11.7645 17.5688 12.0479 17.9927 12.4594 18.1953Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_22638_75033">
          <rect
            width="14.6667"
            height="14.6667"
            fill="white"
            transform="translate(3.6665 3.66602)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default QuestionMark2Icon
